import httpClient from "./httpClient";

const base = "/exam-forth-subject-assign";

export function assignForthSubject(payload) {
  return httpClient.post(base, payload).then((res) => res.data);
}

export function listForthSubjectAssignments(classConfigurationId, academicYear, groupId) {
  return httpClient.get(base, { params: { classConfigurationId, academicYear, groupId } }).then((res) => res.data.data);
}

export function deleteForthSubjectAssignments(ids) {
  const query = new URLSearchParams();
  ids.forEach((id) => query.append("ids", id));
  return httpClient.delete(`${base}?${query.toString()}`).then((res) => res.data);
}
